import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  type InputProps,
} from "@chakra-ui/react";
import { Icon } from "@src/components/ui-kit/Icon";
import type { DateRange } from "@src/utils/types";
import type { FunctionComponent, ReactNode } from "react";
import { formatDate, getDateFromEUFormat } from "..";
import { now } from "../datePicker/DatePicker";

interface InputDateProps extends Omit<InputProps, "onChange"> {
  id?: string;
  error?: ReactNode;
  label?: string;
  isDisabled?: boolean;
  onChange: (value: string, dateRange?: DateRange) => void;
  onBlur?: () => void;
  placeholder?: string;
  value: string;
}

export const InputDate: FunctionComponent<InputDateProps> = function InputDate({
  error,
  label,
  onChange,
  onBlur,
  isDisabled,
  id,
  placeholder,
  value,
  ...inputProps
}) {
  const handleInputChange = (val: string) => {
    try {
      const formattedDate = getDateFromEUFormat(val);

      if (formattedDate) {
        onChange(val, { start: formattedDate, end: formattedDate });
      } else {
        onChange(val, undefined);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <FormControl isInvalid={!!error}>
      {label && <FormLabel>{label}</FormLabel>}
      <InputGroup>
        <Input
          {...inputProps}
          pr="1"
          pl="9"
          id={id}
          isDisabled={!!isDisabled}
          isInvalid={!!error}
          onBlur={onBlur}
          onChange={(e) => handleInputChange(e.target.value)}
          placeholder={placeholder ?? formatDate(now())}
          value={value}
        />
        <InputLeftElement>
          <Icon name="calendar" w="5" h="5" color="grey.500" />
        </InputLeftElement>
      </InputGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
